import React from "react"
import classNames from "classnames"
import { Link as RouterLink } from "react-router-dom"

const isDevelopment = process.env.NODE_ENV === "development"
const isProduction = process.env.NODE_ENV === "production"
const isNetlify = window.location.href.includes("netlify")

const isReactEnvironment = isDevelopment || (isProduction && isNetlify)

export default function Link({ to, children, className, ...rest }) {
  if (isReactEnvironment) {
    return (
      <RouterLink to={to} className={className} {...rest}>
        {children}
      </RouterLink>
    )
  } else {
    const anchorClassName = classNames({
      [className]: !!className,
      active: to === window.location.pathname,
    })

    return (
      <a href={to} className={anchorClassName} {...rest}>
        {children}
      </a>
    )
  }
}
